import { Grid, Stack, Typography } from '@mui/material';

import React from 'react';

import { ITestSelectControlData } from 'features/TestMonitoring/api/type-def';

import styles from './ControlDescription.module.scss';

interface ItestAreaProps {
	controlData: ITestSelectControlData;
	selectedOption: string;
}

const ControlDescription = (props: ItestAreaProps) => {
	const { controlData, selectedOption } = props;

	const selectedControl = controlData.controls.find(
		(control) => control.controlId === selectedOption,
	);

	if (!selectedControl) {
		return null;
	}
	return (
		<Grid spacing={4} className={styles['control-description-grid']}>
			<Grid item>
				<Typography className={styles['control-name']}>
					{selectedControl.controlName}
				</Typography>
			</Grid>
			<Grid item>
				<Stack className={styles['description-stack']}>
					<Typography className={styles['description-header']}>
						Control Description
					</Typography>
					<Typography className={styles['control-description']}>
						{selectedControl.controlDescription}
					</Typography>
				</Stack>
			</Grid>
			<Grid item>
				<Stack className={styles['objective-stack']}>
					<Typography className={styles['description-header']}>
						Control Objective
					</Typography>
					<Typography className={styles['objective-description']}>
						{selectedControl.controlObjective}
					</Typography>
				</Stack>
			</Grid>
		</Grid>
	);
};

export default ControlDescription;
